<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [closable]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  [closeOnEscape]="false"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="flex justify-start items-start flex-col">
      <h1 class="text-xl"><b>Cargar avatar</b></h1>
      <small class="mb-4 italic opacity-80">
        <b>Aquí podrá cargar una imagen de perfil para el usuario.</b>
      </small>
    </div>
  </ng-template>
  <input
    #input
    hidden
    type="file"
    accept=".jpg,.jpeg,.png"
    (change)="fileChangeEvent($event)"
  />

  <div class="justify-items-center m-auto lg:w-180 md:w-180">
    <div class="lg:col-span-4 md:col-span-8 sm:col-span-12 col-span-12">
      @if (imageChangedEvent) {
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1 / 1"
          format="png"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded($event)"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()"
          [transform]="transform"
          [canvasRotation]="canvasRotation"
          [ngClass]="{
            'cursor-grab': !isDragging,
            'cursor-grabbing': isDragging,
          }"
        />
      } @else {
        <div class="justify-items-center m-auto lg:w-120 md:w-120">
          <img src="images/placeholder.svg" alt="" />
        </div>
      }
    </div>
  </div>
  <!-- <div class="justify-items-center m-auto w-180">
    <img hidden [src]="croppedImage" />
  </div> -->
  <ng-template pTemplate="footer">
    <div class="w-full">
      <div class="flex flex-col items-center justify-center">
        <div class="flex justify-between items-center">
          <petrol-icon-button
            icon="pi-replay"
            ariaLabel="Rotar a la izquierda"
            (click)="rotateLeft()"
          />

          <petrol-button class="mx-2" variant="primary" (click)="input.click()">
            <i class="pi pi-upload"></i>
            Subir imagen
          </petrol-button>

          <petrol-icon-button
            icon="pi-refresh"
            ariaLabel="Rotar a la derecha"
            (click)="rotateRight()"
          />
        </div>

        <div class="flex justify-between items-center gap-4 mt-2">
          <petrol-icon-button
            icon="pi-minus"
            ariaLabel="Alejar"
            [disabled]="zoom <= 1"
            (click)="zoomOut()"
          />

          <petrol-icon-button
            icon="pi-plus"
            ariaLabel="Acercar"
            [disabled]="zoom >= 3"
            (click)="zoomIn()"
          />
        </div>
      </div>

      <div class="flex justify-end gap-3 mt-2">
        <petrol-button variant="primary" (click)="onButtonClick()">
          Confirmar
        </petrol-button>
        <petrol-button
          variant="secondary"
          (click)="close()"
        >
          Cancelar
        </petrol-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
